// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"8":"editor","419":"wiki","542":"overview","884":"admin"}[chunkId] + "." + {"8":"73b6f364","419":"34646de9","542":"5a74eb0e","884":"b9d26179"}[chunkId] + ".css";
};